import { makeStyles } from 'tss-react/mui';

export const useChatMessageItemStyles = makeStyles<void, 'handleErrorMessageWrapper'>()(
  (theme, _params, classes) => ({
    wrapper: {
      backgroundColor: 'white',
      [`&:hover .${classes.handleErrorMessageWrapper}`]: {
        display: 'flex',
      },
    },
    avatar: {
      alignSelf: 'flex-end',
      width: theme.spacing(5),
    },
    message: {
      wordBreak: 'break-all',
    },
    messageTimestamp: {
      fontSize: '8px',
      color: theme.palette.grey[500],
      alignSelf: 'flex-end',
    },
    handleErrorMessageWrapper: {
      display: 'none',
    },
  }),
);
